export enum FamilyStepsEnum {
  preStepFamilyType = 'pre_step_family_type',
  generalBase = 'general_base',
  generalSecond = 'general_second',
  childBodyParameters = 'child_body_parameters',
  childHairColor = 'child_hair_color',
  childEyeColor = 'child_eye_color',
  childBodyArtTypes = 'child_body_art_types',
  share = 'share',
  congratulations = 'congratulations',
}
